import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition
} from '@angular/material/snack-bar';
import {
  ToastTypesComponent,
  ToastErrorComponent,
  ToastSuccessComponent,
  ToastWarningComponent
} from 'src/app/layouts/main-layout/components/toast-types/toast-types.component';

@Injectable({
  providedIn: 'root'
})
export class ToastCustomService {
  private durationInSeconds = 5;
  private horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  private verticalPosition: MatSnackBarVerticalPosition = 'top';

  private handlerType = {
    success: ToastSuccessComponent,
    warning: ToastWarningComponent,
    error: ToastErrorComponent
  };

  private handlerClass = {
    success: 'snack-bar-success',
    warning: 'snack-bar-warning',
    error: 'snack-bar-error'
  }

  constructor(private _snackBar: MatSnackBar) { }

  public show(type: 'success' | 'warning' | 'error', title: string, subtitle: string): void {
    const snackBarRef = this._snackBar.openFromComponent(this.handlerType[type], {
      duration: this.durationInSeconds * 1000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: this.handlerClass[type]
    });
    (snackBarRef.instance as ToastTypesComponent).title = title;
    (snackBarRef.instance as ToastTypesComponent).subtitle = subtitle;
  }
}
